
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/it-admins",
      function () {
        return require("private-next-pages/for/it-admins.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for/it-admins"])
      });
    }
  